import type {
  DefinitionComponent,
  BlockReference,
  BlockComponent,
  ObjectReference
} from "../survey";

export const ReferenceableBlocks = ['Attachment','Explanation','Select','Validated', 'Computed'] as const;
export const ReferenceableObjects = ['ReviewConfiguration'] as const;

export type ReferenceBlocks = `${typeof ReferenceableBlocks[number]} Reference`;
export type ReferenceObjects = `${typeof ReferenceableObjects[number]} Reference`;

export const referenceBlocksArray: ReferenceBlocks[] = ReferenceableBlocks.map(b => `${b} Reference` as const);
export const referenceObjectsArray: ReferenceObjects[] = ReferenceableObjects.map(o => `${o} Reference` as const);

type BlockDefinitionComponent = Extract<DefinitionComponent, { kind: typeof ReferenceableBlocks[number] }>;

function isObjectReference(ref: BlockReference | ObjectReference): ref is ObjectReference {
  return (referenceObjectsArray as readonly string[]).includes(ref.kind);
}

export function replaceReferenceWithDefinition(
  reference: BlockReference | ObjectReference,
  definition: DefinitionComponent,
): (BlockComponent & { id: string }) | Object | null {
  // First check that the definition is the same kind as the reference and that the ids match
  if (reference.kind !== (definition.kind + ' Reference') || reference.definitionId !== definition.definitionProps.id) {
    console.error("Reference", reference, "is not the same kind as the definition", definition);
    return null;
  }

  // Object Reference: replace with inline config (no BlockComponent, no id)
  if (isObjectReference(reference)) {
    const { definitionProps: _definitionProps, ...inlineConfig } = definition;
    return inlineConfig;
  }

  // Only block references remain (referenceBlocksArray kinds)
  const blockDefinition = definition as BlockDefinitionComponent;
  const { kind: _kind, definitionId: _definitionId, ...referenceProps } = reference;
  return {
    ...blockDefinition,
    ...referenceProps
  } satisfies BlockComponent & { id: string };
}
